import { useMemo } from "react";
import { cn, formatCreatedAt } from "@/lib/utils";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/lib/components/Tooltip";
import { Badge } from "@/lib/components/Badge";

export function VoiceoverInfo({
  isCurrentVoiceover,
  title,
  actor,
  duration,
  createdAt,
  actionsChildren,
  variant,
}: {
  isCurrentVoiceover: boolean;
  title: string;
  actor: string | undefined;
  duration?: string | null;
  createdAt?: string;
  variant: "selected" | "list";
  actionsChildren?: React.ReactNode;
}) {
  const isList = variant === "list";

  const timestamp = useMemo(
    () => (createdAt ? formatCreatedAt(createdAt, null) : undefined),
    [createdAt],
  );

  return (
    <div
      className={cn(
        "group relative flex items-center",
        isList
          ? "-mx-3 rounded-lg px-3 py-2 transition-colors duration-100 hover:bg-grey-100"
          : "h-14",
      )}
    >
      <div className="ml-1.5 flex flex-1 flex-col overflow-hidden">
        <Tooltip>
          <TooltipTrigger asChild>
            <span
              className={cn(
                "truncate text-sm text-text-primary",
                isList ? "font-medium" : "font-semibold",
              )}
            >
              {title}
            </span>
          </TooltipTrigger>
          <TooltipContent className="max-w-md whitespace-normal">
            {title}
          </TooltipContent>
        </Tooltip>
        <div className="mt-1 flex h-6 items-center gap-1.5">
          <span className="truncate pb-1 text-sm text-text-secondary">
            {actor}
            {duration && ` - ${duration}`}
            {timestamp && ` - ${timestamp}`}
          </span>
          {isCurrentVoiceover && (
            <Badge variant="gradient" className="shrink-0">
              Current voiceover
            </Badge>
          )}
        </div>
      </div>
      <div
        className={cn(
          "flex items-center gap-3",
          isList &&
            "pointer-events-none absolute top-1/2 right-3 -translate-y-1/2 opacity-0 group-focus-within:pointer-events-auto group-focus-within:static group-focus-within:right-0 group-focus-within:translate-y-0 group-focus-within:pl-4 group-focus-within:opacity-100 group-hover:pointer-events-auto group-hover:static group-hover:right-0 group-hover:translate-y-0 group-hover:pl-4 group-hover:opacity-100",
        )}
      >
        {actionsChildren}
      </div>
    </div>
  );
}
